const config = {
  development: {
    IDENTITY_POOL: 'us-west-2:48df7b6f-1a8e-4e5e-82d1-5d8dcc9bf7af',
    REGION: 'us-west-2',
    USER_POOL: 'us-west-2_JvLPOom6s',
    USER_POOL_CLIENT_ID: '8vqd4dsncqcj7gsmckmk0f2vb',
    AMAZON_COGNITO_DOMAIN: 'kambria-dev.auth.us-west-2.amazoncognito.com',
    CLIENT_ID: '8vqd4dsncqcj7gsmckmk0f2vb',
    FACEBOOK_APP_ID: '939176423518526',
    GOOGLE_CLIENT_ID: '806156560009-aqd6nv9o8j5g2ki41ikgovne1gcvkp8j.apps.googleusercontent.com',
    COOKIE_STORAGE_DOMAIN: 'kambria.io',
  },
  staging: {
    IDENTITY_POOL: 'us-west-2:48df7b6f-1a8e-4e5e-82d1-5d8dcc9bf7af',
    REGION: 'us-west-2',
    USER_POOL: 'us-west-2_JvLPOom6s',
    USER_POOL_CLIENT_ID: '8vqd4dsncqcj7gsmckmk0f2vb',
    AMAZON_COGNITO_DOMAIN: 'kambria-dev.auth.us-west-2.amazoncognito.com',
    CLIENT_ID: '8vqd4dsncqcj7gsmckmk0f2vb',
    FACEBOOK_APP_ID: '939176423518526',
    GOOGLE_CLIENT_ID: '806156560009-aqd6nv9o8j5g2ki41ikgovne1gcvkp8j.apps.googleusercontent.com',
    COOKIE_STORAGE_DOMAIN: 'kambria.io',
  },
  uat: {
    IDENTITY_POOL: 'us-west-2:48df7b6f-1a8e-4e5e-82d1-5d8dcc9bf7af',
    REGION: 'us-west-2',
    USER_POOL: 'us-west-2_JvLPOom6s',
    USER_POOL_CLIENT_ID: '8vqd4dsncqcj7gsmckmk0f2vb',
    AMAZON_COGNITO_DOMAIN: 'kambria-dev.auth.us-west-2.amazoncognito.com',
    CLIENT_ID: '8vqd4dsncqcj7gsmckmk0f2vb',
    FACEBOOK_APP_ID: '939176423518526',
    GOOGLE_CLIENT_ID: '806156560009-aqd6nv9o8j5g2ki41ikgovne1gcvkp8j.apps.googleusercontent.com',
    COOKIE_STORAGE_DOMAIN: 'kambria.io',
  },
  production: {
    IDENTITY_POOL: 'us-west-2:bb49991a-dac8-4cfc-8781-cfeee22f81e6',
    REGION: 'us-west-2',
    USER_POOL: 'us-west-2_45T9iCzrv',
    USER_POOL_CLIENT_ID: '521bkpo7mbeq59l70fkh9rgeqq',
    AMAZON_COGNITO_DOMAIN: 'kambria.auth.us-west-2.amazoncognito.com',
    CLIENT_ID: '521bkpo7mbeq59l70fkh9rgeqq',
    FACEBOOK_APP_ID: '2003855713150063',
    GOOGLE_CLIENT_ID: '806156560009-aqd6nv9o8j5g2ki41ikgovne1gcvkp8j.apps.googleusercontent.com',
    COOKIE_STORAGE_DOMAIN: 'kambria.io',
  },
};

export default config;
